import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AdminTable from 'layouts/AdminTable';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import gastro from 'helpers/gastro';
import { post, put } from 'helpers/apiHelpers';
import { combineStyles } from 'helpers/helpers';
import FormTextInputTranslatable from 'components/FormTextInput/FormTextInputTranslatable';
import { toast } from 'react-toastify';
import { useGetCompanyDefaultLanguage } from 'hooks/redux/Translatable/useTranslatableLanguages';

import defaultState from './defaultState';

const Form = ({
  match,
  classes,
  history,
  valueUrl,
  valueKey,
  location,
  translatable = false,
}) => {
  const companyDefaultLanguage = useGetCompanyDefaultLanguage();
  const { t } = useTranslation();
  const [state, setState] = useState({ ...defaultState });

  const isEdit = location.pathname.includes('edit');
  const elementId = match.params.id;

  useEffect(() => {
    if (isEdit) {
      // eslint-disable-next-line no-use-before-define -- FIXME
      fetchValue();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const fetchValue = () => {
    gastro
      .get(`${valueUrl}/${elementId}`, {
        params: { translations: translatable },
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(({ data }) => {
        setState({
          ...state,
          name: data.value,
          position: data.position,
        });
      });
  };

  const handleInputChange = event => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const validateForm = () =>
    translatable
      ? state.name['@ContentTranslation'][companyDefaultLanguage]
      : state.name;

  // eslint-disable-next-line consistent-return -- FIXME
  const handleSubmit = () => {
    if (!validateForm()) {
      return toast.error(t('form.nameFieldCannotBeEmpty'));
    }
    const data = {
      [valueKey || 'value']: state.name,
      // eslint-disable-next-line radix -- FIXME
      position: parseInt(state.position),
    };

    const action = isEdit
      ? put(`${valueUrl}/${elementId}`, data)
      : post(valueUrl, data);

    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    action.then(() => history.push(`/admin/${valueUrl}`));
  };
  const NameComponent =
    // eslint-disable-next-line no-negated-condition -- FIXME
    translatable !== true ? FormTextInput : FormTextInputTranslatable;

  return (
    <AdminTable title={isEdit ? t('form.editValue') : t('form.addNewValue')}>
      <NameComponent
        label={`${t('form.field.name')}*`}
        classes={classes}
        name="name"
        value={state.name}
        handleChange={handleInputChange}
        inputSize={4}
      />
      <FormTextInput
        label={`${t('form.field.order')}*`}
        classes={classes}
        name="position"
        value={state.position}
        type="number"
        handleChange={handleInputChange}
        inputSize={2}
      />
      <FormControlButtons
        classes={classes}
        discardText={t('form.cancel')}
        submitText={t('form.save')}
        cancelPath={`/admin/${valueUrl}`}
        handleSubmit={handleSubmit}
      />
    </AdminTable>
  );
};

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

export default withStyles(combinedStyles)(Form);
